export default "__VITE_ASSET__CzwoBI$c__"